import { render, staticRenderFns } from "./InfoAntiCorruption.vue?vue&type=template&id=3877c05d"
import script from "./InfoAntiCorruption.vue?vue&type=script&lang=js"
export * from "./InfoAntiCorruption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports